import { render, staticRenderFns } from "./Qiang.vue?vue&type=template&id=5f0dc928&scoped=true&"
import script from "./Qiang.vue?vue&type=script&lang=js&"
export * from "./Qiang.vue?vue&type=script&lang=js&"
import style0 from "./Qiang.vue?vue&type=style&index=0&id=5f0dc928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0dc928",
  null
  
)

export default component.exports